import { DropdownItem } from '@designsystem/stories/02-atoms/Dropdown';

/**
 * Filter indexes whose active filter switches a listing to relevance sorting.
 * The backend makes the ranking work: a topic filter alone carries no fulltext
 * term and would otherwise be answered by the ZCatalog, which has no scores
 * (see `services/topic_relevance.py`, #1653).
 */
export const RELEVANCE_SORT_INDEXES = ['SearchableText', 'topics'];

/** The fulltext filter is kept under its own key, not under its index name. */
const ACTIVE_FILTER_KEYS: Record<string, string> = {
  SearchableText: 'fulltext',
};

/**
 * Whether the active filters switch the listing to relevance sorting.
 *
 * Reads the *applied filters*, not the resolved query: a topic that a listing
 * carries in its own base query is not a filter the visitor applied and must
 * not override the configured sort order. Client and SSR share this function
 * so both arrive at the same sort order for the same URL.
 */
export function hasRelevanceTrigger(
  activeFilters: Record<string, unknown> | undefined | null,
): boolean {
  if (!activeFilters) return false;

  return RELEVANCE_SORT_INDEXES.some((index) => {
    const value = activeFilters[ACTIVE_FILTER_KEYS[index] ?? index];
    return Array.isArray(value) ? value.length > 0 : !!value;
  });
}

export const PRIORITY_FILTER_VALUES: Record<string, string[]> = {
  target_audience: [
    'teachers_cycle1',
    'teachers_cycle2',
    'teachers_cycle3',
    'school_administrators',
  ],
};

export function sortFilterValues(
  values: DropdownItem[],
  filterIndex: string,
): void {
  const priorityValues = PRIORITY_FILTER_VALUES[filterIndex];
  if (priorityValues) {
    values.sort((a, b) => {
      const aIdx = priorityValues.indexOf(a.value as string);
      const bIdx = priorityValues.indexOf(b.value as string);
      if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
      if (aIdx !== -1) return -1;
      if (bIdx !== -1) return 1;
      return (a.label as string).localeCompare(b.label as string);
    });
  } else {
    values.sort((a, b) => (a.label as string).localeCompare(b.label as string));
  }
}
